import { render, staticRenderFns } from "./alarmConfig.vue?vue&type=template&id=6f7a842a"
import script from "./alarmConfig.vue?vue&type=script&lang=js"
export * from "./alarmConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7a842a')) {
      api.createRecord('6f7a842a', component.options)
    } else {
      api.reload('6f7a842a', component.options)
    }
    module.hot.accept("./alarmConfig.vue?vue&type=template&id=6f7a842a", function () {
      api.rerender('6f7a842a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openConfig/alarmConfig.vue"
export default component.exports